module.exports = __webpack_public_path__ + "static/img/img1.9980f6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/img1.png
// module id = lwyQ
// module chunks = 1